import React, { FunctionComponent } from 'react';
import { useAboutCareersContent } from '../../../graphql/pimcore/modules/siteContent/hooks/useAboutCareersContent';
import { useLocale } from '../../../contexts/LocaleProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import DebouncedLoader from '../../common/DebouncedLoader';
import { IntlProvider } from 'react-intl';
import { Box } from '@mui/material';
import ReusableTabs from '../../common/ReusableTabs';

import * as styles from '../../productPage/tableComponents/ProductPage_style';
import BreadCrumbs from '../../common/BreadCrumbs';
import bannerImg from '../../../static/ynex/EABanner.jpg';
import HVACOverViewPage from './HVACOverViewPage';
import { toUrl } from '@/utils/convertImagePath';

const bannerTitle = 'Temperature Sensors for HVAC & Building Automation';
const bannerDescription =
    'Temperature sensors ensure precise HVAC control—from indoor comfort to pipe and duct monitoring—boosting efficiency in heating, cooling, and energy metering across furnaces, pumps, chillers, AC systems, and smart controls.';

const HVACPage: FunctionComponent = () => {
    const { loading, error, contentTree } = useAboutCareersContent();

    const { locale, messages } = useLocale();
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <DebouncedLoader loading={loading} delay={1000} size={40} centered>
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <Box
                    width="100%"
                    component="main"
                    sx={{
                        padding: 0,
                        flexGrow: 0,
                        p: 0,
                    }}
                >
                    <ReusableTabs
                        bannerImage={toUrl(bannerImg)}
                        bannerTitle={bannerTitle}
                        bannerDescription={bannerDescription}
                        tabLabels={['Overview', 'Products', 'Datasheets', 'Resources']}
                        tabKeys={['Overview', 'Products', 'Datasheets', 'Resources']}
                        // tabKeys={['Innovate with Us', 'SearchJobs']}
                        tabContents={[
                            <HVACOverViewPage key="overview" />,
                            // <JobPage cmsContent={contentTree.SearchJobs} />,
                        ]}
                        bannerFontStyle={styles.bannerFont}
                        subBannerFontStyle={styles.bannerFont2}
                        pageName={contentTree.pageTitle.content}
                        showTabs={true}
                        breadcrumbs={<BreadCrumbs navigationPath="/Home/Applications/hvac" />}
                    />
                </Box>
            </IntlProvider>
        </DebouncedLoader>
    );
};

export default HVACPage;
